import { Action } from '../actions/station-hours';

const defaultState = {
  isFetching: false,
  byStationId: {},
  error: undefined,
};

export default function stationHoursReducer(state = defaultState, action) {
  const body = action?.payload;
  const { byStationId } = state;

  switch (action?.type) {
    case Action.StationHours.StationHoursCompleted:
      // Only store station hours if they exist
      if (body.hours) {
        byStationId[body.station_id] = body.hours;
      }

      return {
        isFetching: false,
        byStationId: {
          ...byStationId,
        },
      };

    case Action.StationHours.StationHoursFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    case Action.StationHours.StationHoursPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    default:
      return state;
  }
}
